import { CookieStorage } from '@crossnokaye/ux-smarts';

import { COOKIE_DOMAIN } from './constants';

export const cookieStorage = new CookieStorage({
  domain: COOKIE_DOMAIN,
  maxAge: 30,
  path: '/',
  sameSite: 'lax',
});
